import * as z from "zod/v4";
import { exampleStreamChannelSchema } from "./example";
import {
  teamNotificationsStreamChannelSchema,
  userNotificationsStreamChannelSchema,
} from "./definitions";
import { tasksStreamChannelSchema } from "./tasks";

export const streamChannelSchemaRegistry = {
  example: exampleStreamChannelSchema,
  tasks: tasksStreamChannelSchema,
  "team-notifications": teamNotificationsStreamChannelSchema,
  "user-notifications": userNotificationsStreamChannelSchema,
} as const;

export type RegisteredStreamChannelName =
  keyof typeof streamChannelSchemaRegistry;

export type StreamChannelSchemaFor<
  TChannel extends RegisteredStreamChannelName,
> = (typeof streamChannelSchemaRegistry)[TChannel];

const registeredChannelNames = Object.keys(streamChannelSchemaRegistry) as [
  RegisteredStreamChannelName,
  ...RegisteredStreamChannelName[],
];

export const streamChannelNameSchema = z.enum(registeredChannelNames);
export type StreamChannelName = z.infer<typeof streamChannelNameSchema>;
